import { render, staticRenderFns } from "./momentsAgo.vue?vue&type=template&id=3f8e8032&"
import script from "./momentsAgo.vue?vue&type=script&lang=js&"
export * from "./momentsAgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports